import React, { useEffect, useState } from "react";
import "./Styles/ExtraOffers.css";
import amazon from "./images/amazon-img-1.png";
import { Link, useParams } from "react-router-dom";
import { baseURL, getDeal } from "../services/Aut.post.js";
function ClaimPage() {
  const [openUrl, setOpenUrl] = useState();
  const { unq_id } = useParams();
  const handleClick = () => {
    const redirectUrl = `/order-id/${unq_id}`;

    window.open(openUrl, "_blank");

    window.location.href = redirectUrl;
  };

  const [getDealOne, setGetDealOne] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getDeal(unq_id);
        setGetDealOne(data);
        setOpenUrl(data.affiliate_link);
      } catch (error) {
        // Handle error if needed
      }
    };

    fetchData();
  }, []);
  return (
    <>
      <div className="top-space-1">
        <div className="claim-page">
          <div className="claim-page-bg">
            <div className="claim-page-header">
              <img
                src={
                  getDealOne.marketplace_image
                    ? `${baseURL}/${getDealOne.marketplace_image}`
                    : amazon
                }
                alt={getDealOne.unq_id || "product"}
              />
            </div>

            <h4>50-90% Off Across Categories</h4>
            <h3>{getDealOne.tockens_benefit}</h3>

            <button className="button-orange-1 w-80" onClick={handleClick}>
              Earn {getDealOne.visited_tockens} Tokens
            </button>
          </div>

          <div className="backhome">
            <Link to="/">Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClaimPage;
